import { useQuery } from "react-query";
import { getReservations } from "../../services/library/reservation";
import { key_reservations } from "../../utils/constants";
import { PagedRequestType } from "../../types/PagedResults";

export const useGetReservationsQuery = (data: PagedRequestType, options: any = null) =>
    useQuery(
        [key_reservations, JSON.stringify(data)],
        () => getReservations(data),
        options ? { ...options } : {}
    );
